import React from 'react';
import { Footer } from '../components/HomePage';
import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import AllCircles from '../components/AllCircles/AllCircles';

function AllCirclesPage() {
  return (
    <>
      <HowItWorksHeader />
      <AllCircles />
      <Footer />
    </>
  );
}

export default AllCirclesPage;